/**
 * Scores (spec 02 §7): stored as the C64 stored them, displayed points / 10, and paid out with
 * the extra lives they earn. Every system that awards points calls `addScore`.
 */

import { EXTRA_LIFE_AT, MAX_LIVES } from './tuning';
import type { PlayerId, World } from './types';

/** Add `units` (displayed points / 10) to a player's score; pays at most one extra life per call. */
export function addScore(world: World, id: PlayerId, units: number): void {
  const p = world.players[id];
  if (p.state === 'out' || p.state === 'gameOver') return;
  p.score += units;
  const next = EXTRA_LIFE_AT[p.nextExtraLife];
  if (next !== undefined && p.score * 10 >= next) {
    p.nextExtraLife++;
    p.lives = Math.min(MAX_LIVES, p.lives + 1);
    world.events.push({ type: 'extraLife', player: id });
  }
}

/** Displayed points for a stored score. */
export const displayScore = (units: number): number => units * 10;
